import React, { Component } from 'react';
import EcommercePanel from './EcommercePanel';
import NewsPanel from './NewsPanel';
import SocialPanel from './SocialPanel';
import DemoImage from './DemoImage';
import Scroll from 'react-scroll';
import {sections} from '../constants';

export default class ImplementationsPanel extends Component {
  
  handleClick (section) {
    return (e) => {
      e.preventDefault();
      this.props.setCurrentSection(section);
    };
  }

  render() {

    if (this.props.publicId) {
      return (
        <div className="panel-website">
          <div className="banner-img">
            <DemoImage publicId={this.props.publicId} transformation={[{ height: 764, width: 'auto', crop: 'fill', gravity: 'face' }, { effect: 'brightness_hsb:-60' }, { dpr: 'auto', effect: 'blur:400' }]} format="jpg" imageStyle={{ width: '100%' }} showDetails={this.props.showDetails}>
              <p>Create a background image to match your design.</p><ul><li>Resize and crop the image</li><li>Adjust the image brightness in HSB to prevent artifacts in some images</li><li>Add a blur effect</li></ul>
            </DemoImage>
          </div>
          <div className="container">
            <header className="heading text-center">
              <h1 className="text-uppercase">Popular implementations</h1>
              <ul className="list-inline">
                <li><a href="#" className="btn btn-white" onClick={this.handleClick(sections.ECOMMERCE)}><span>E-commerce sites</span></a></li>
                <li><a href="#" className="btn btn-white" onClick={this.handleClick(sections.NEWS)}><span>News &amp; media sites</span></a></li>
                <li><a href="#" className="btn btn-white" onClick={this.handleClick(sections.SOCIAL)}><span>Social sites &amp; apps</span></a></li>
              </ul>
            </header>
            
            <Scroll.Element name={sections.ECOMMERCE}/>
            <EcommercePanel {...this.props}/>
            
            <Scroll.Element name={sections.NEWS}/>
            <NewsPanel {...this.props}/>
            
            <Scroll.Element name={sections.SOCIAL}/>
            <SocialPanel {...this.props}/>
          </div>
        </div>
      );
    } else {
      return <div/>;
    }
  }
}


/** WEBPACK FOOTER **
 ** ./src/js/components/ImplementationsPanel.js
 **/